export const localStorageKeys = {
  accessToken: 'accessToken',
  refreshToken: 'refreshToken',
  accessTokenExpiresIn: 'accessTokenExpiresIn',
  refreshTokenExpiresIn: 'refreshTokenExpiresIn',
  userData: 'userData',
  returnPath: 'returnPath'
}

export const getUserDataFromLocalstorage = () => JSON.parse(localStorage.getItem(localStorageKeys.userData))
export const setUserDataToLocalstorage = (userData) => localStorage.setItem(localStorageKeys.userData, JSON.stringify(userData))
export const removeUserDataFromLocalstorage = () => localStorage.removeItem(localStorageKeys.userData)

export const getAccessTokenFromLocalstorage = () => JSON.parse(localStorage.getItem(localStorageKeys.accessToken))
export const setAccessTokenToLocalstorage = (accessToken) => localStorage.setItem(localStorageKeys.accessToken, JSON.stringify(accessToken))
export const removeAccessTokenFromLocalstorage = () => localStorage.removeItem(localStorageKeys.accessToken)

export const getRefreshTokenFromLocalstorage = () => JSON.parse(localStorage.getItem(localStorageKeys.refreshToken))
export const setRefreshTokenToLocalstorage = (refreshToken) => localStorage.setItem(localStorageKeys.refreshToken, JSON.stringify(refreshToken))
export const removeRefreshTokenFromLocalstorage = () => localStorage.removeItem(localStorageKeys.refreshToken)

export const getAccessTokenExpiresInFromLocalstorage = () => JSON.parse(localStorage.getItem(localStorageKeys.accessTokenExpiresIn))
export const setAccessTokenExpiresInToLocalstorage = (accessTokenExpiresIn) => {
  localStorage.setItem(localStorageKeys.accessTokenExpiresIn, JSON.stringify(accessTokenExpiresIn))
}
export const removeAccessTokenExpiresInFromLocalstorage = () => localStorage.removeItem(localStorageKeys.accessTokenExpiresIn)

export const getRefreshTokenExpiresInFromLocalstorage = () => JSON.parse(localStorage.getItem(localStorageKeys.refreshTokenExpiresIn))
export const setRefreshTokenExpiresInToLocalstorage = (refreshTokenExpiresIn) => {
  localStorage.setItem(localStorageKeys.refreshTokenExpiresIn, JSON.stringify(refreshTokenExpiresIn))
}
export const removeRefreshTokenExpiresInFromLocalstorage = () => localStorage.removeItem(localStorageKeys.refreshTokenExpiresIn)

export const setReturnPathToLocalstorage = (path) => localStorage.setItem(localStorageKeys.returnPath, path)
export const getReturnPathFromLocalstorage = () => localStorage.getItem(localStorageKeys.returnPath)

export const getIsPasswordStillDefaultFromLocalstorage = () => {
  const raw = localStorage.getItem('isPasswordStillDefault')
  if (raw === undefined || raw === null) return null
  try { return JSON.parse(raw) } catch { return null }
}

export const setIsPasswordStillDefaultToLocalstorage = (isPasswordStillDefault) => {
  if (isPasswordStillDefault === undefined || isPasswordStillDefault === null) {
    try { localStorage.removeItem('isPasswordStillDefault') } catch {}
    return
  }
  localStorage.setItem('isPasswordStillDefault', JSON.stringify(!!isPasswordStillDefault))
}

export const removeIsPasswordStillDefaultFromLocalstorage = () => localStorage.removeItem('isPasswordStillDefault')

export const clearAuthKeysFromLocalstorage = () => {
  removeUserDataFromLocalstorage()
  removeAccessTokenFromLocalstorage()
  removeRefreshTokenFromLocalstorage()
  removeAccessTokenExpiresInFromLocalstorage()
  removeRefreshTokenExpiresInFromLocalstorage()
  removeIsPasswordStillDefaultFromLocalstorage()
}
